<div [class]="{'modal_contents':true, 'open': open_settings}">
  <div class="bg">
    <div class="title">
      <div  class="text">
        <h2>Настройки сайта</h2>
      </div>
      <div>
        <button class="close" (click)="SettingsService.set_open_settings(false)">
          <i class="icon"></i>
        </button>
      </div>
    </div>
    <div class="settings_list">
      <ul>
        <li (click)="SettingsService.set_showHintAfterWrongAnswer()">
          <div class="text">
            Отображать подсказку после неправильного ответа
          </div>
          <div>
            <span [class]="{'radio_button': true, 'active': SettingsService.showHintAfterWrongAnswer && !SettingsService.showResultsOnlyAfterCompletion}"></span>
          </div>
        </li>
        <li (click)="SettingsService.set_showHintAfterCorrectAnswer()">
          <div class="text">
            Отображать подсказку после правильного ответа
          </div>
          <div>
            <span [class]="{'radio_button': true, 'active': SettingsService.showHintAfterCorrectAnswer && !SettingsService.showResultsOnlyAfterCompletion}"></span>
          </div>
        </li>
        <li (click)="SettingsService.set_autoNextQuestionAfterCorrectAnswer()">
          <div class="text">
            Автопереход после правильного ответа
          </div>
          <div>
            <span [class]="{'radio_button': true, 'active': SettingsService.autoNextQuestionAfterCorrectAnswer ||  SettingsService.showResultsOnlyAfterCompletion}"></span>
          </div>
        </li>
        <li (click)="SettingsService.set_autoNextQuestionAfterWrongAnswer()">
          <div class="text">
            Автопереход после неправильного ответа
          </div>
          <div>
            <span [class]="{'radio_button': true, 'active': SettingsService.autoNextQuestionAfterWrongAnswer  ||  SettingsService.showResultsOnlyAfterCompletion}"></span>
          </div>
        </li>
        <li (click)="SettingsService.set_showResultsOnlyAfterCompletion()">
          <div class="text">
            Показывать результаты теста только после завершения
          </div>
          <div>
            <span [class]="{'radio_button': true, 'active': SettingsService.showResultsOnlyAfterCompletion}"></span>
          </div>
        </li>
      </ul>
      <div class="delete" (click)="set_delete_statistics()">
        <div>
          <div>
            <b>Сбросить статистику прохождения</b>
          </div>
          <div>
            Будет удалена вся история ваших ответов: правильные и ошибочные ответы во всех разделах сайта — марафон, билеты и категории.
          </div>
        </div>
        <div>
          <button>
            <div>
              Удалить
            </div>
            <div>
              <i class="icon"></i>
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
